import React, { useEffect, useState } from 'react';
import { ToggleButtonGroup, ToggleButton, Box } from '@mui/material';
import { FixedOption, FixedOptions } from '../page-data/fixed-option-data';
import { ITSEventType, ReviewClickEventData } from '../common/page-data';
import { PageData } from '../page-data/page-data';
import { Review } from './review';
interface ComponentProps {
  isTeacherView: boolean;
  options: FixedOptions;
  pageData: PageData;
  answer: string;
  reason: string;
  isReview: boolean;
  onReviewed?: null | ((option: any) => void);
  onChange?: null | ((option: any) => void);
}

type Props = ComponentProps;

export const FixedOptionsComp: React.FC<Props> = (props) => {
  const { isTeacherView, options, pageData, answer, reason, isReview } = props;
  const [selection, setSelection] = useState<string>();

  useEffect(() => {
    let selection;
    Object.values(options).forEach((option) => {
      if (option.selected) selection = option.name;
    });
    setSelection(selection);
  }, [options]);

  const onReviewed = (option: FixedOption): void => {
    const data: ReviewClickEventData = {
      id: option.name,
    };
    pageData.recordEvent(ITSEventType.reviewClick, data);
    if (props.onReviewed) props.onReviewed(option);
  };

  const updateSelection = (
    event: React.MouseEvent<HTMLElement>,
    newSel: string | null
  ) => {
    if (newSel) {
      setSelection(newSel);
    } else {
      setSelection('');
    }
    Object.values(options).forEach((v) => {
      const vSelected = newSel === v.name;
      if (v.selected !== vSelected) {
        pageData.recordEvent(ITSEventType.selectOption, {
          id: v.name,
          selected: vSelected,
          correctOption: v.name === answer,
        });
        if (props.onChange) props.onChange(v);
      }
      v.selected = vSelected;
    });
  };

  return (
    <ToggleButtonGroup
      value={selection}
      exclusive
      color='primary'
      orientation='vertical'
      onChange={updateSelection}
      sx={{
        comment: 'fixed options button group',
        width: '100%',
        mt: 1,
        '& .MuiToggleButtonGroup-grouped': {
          mb: 0.5,
        },
      }}
    >
      {Object.values(options).map((option) => {
        const isCorrectResponse = option.name === answer;
        return (
          <ToggleButton
            value={option.name}
            key={option.name}
            sx={{
              width: '100%',
              display: 'inline-flex',
              justifyContent: 'space-between',
              alignItems: 'stretch',
              padding: 0,
              pointerEvents: isReview ? 'none' : 'auto',
              '& .MuiToggleButton-root': {
                borderRadius: '4px',
              },
            }}
          >
            <Box sx={{ p: 2, textAlign: 'start' }}>
              {option.name}
            </Box>
            {isReview && (
              <Review
                hasRequestReviewPrompt={!isTeacherView}
                isCorrectResponse={isCorrectResponse}
                isSelected={option.selected}
                onReviewed={() => onReviewed(option)}
                reason={isCorrectResponse ? reason : undefined}
              />
            )}
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
};
